import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import { Form } from 'components/organisms';
import {
  labelInitialValues,
  LabelTabs,
} from 'components/organisms/forms/label/LabelForm';
import { useHasPermission } from 'hooks';
import { useParamId } from 'hooks/useParamId';
import i18next from 'i18next';
import middleware from 'middleware';
import { PiPencilSimpleLine, PiPhoneTransfer } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDeleteLabel, useGetLabel, useGetVcfLabel } from 'services/labels';
import { STATUS } from 'services/types';

const Label = () => {
  const labelId = useParamId('label');
  const { pathname } = useLocation();
  const { isPending, mutateAsync } = useDeleteLabel();
  const { mutate: downloadVcfLabel, isPending: isDownloading } =
    useGetVcfLabel();

  const navigate = useNavigate();
  const hasPermission = useHasPermission();

  const { data: label, isLoading } = useGetLabel(labelId);

  const handleDeleteLabel = async () => {
    await mutateAsync(labelId, {
      onSuccess: () => navigate('/label'),
    });
  };

  return (
    <Form.Label
      i18nextPrefix='label'
      initialValues={
        label ? middleware.label.queryToForm(label) : labelInitialValues
      }
      onSubmit={() => {}}
      tittle={label?.labelName ?? i18next.t('label.title.individual')}
      backPath='label'
      disableTabs={[
        ...(label?.labelStatus === STATUS.draft
          ? [
              LabelTabs.advance,
              LabelTabs.balance,
              LabelTabs.contracts,
              LabelTabs.reports,
              LabelTabs.settlements,
              LabelTabs.statistics,
            ]
          : []),
      ]}
      status={{ displayMode: true, isLoading }}
      topbarContent={
        <div className='flex gap-2 items-center'>
          <Button
            type='button'
            onlyIcon
            isClear
            onClick={() => downloadVcfLabel(labelId)}
            disabled={isDownloading}>
            <Button.Icon icon={<PiPhoneTransfer />} />
          </Button>
          {hasPermission('LabelPermissionsLIST**', 2) && (
            <Button
              isClear
              onlyIcon
              onClick={() => {
                label &&
                  navigate(`/label/edit/${labelId}/finances`, {
                    replace: true,
                  });
              }}>
              <Button.Icon icon={<PiPencilSimpleLine />} />
            </Button>
          )}
          {hasPermission('LabelPermissionsLIST**', 4) && (
            <MagellanPopups.DeleteWarning
              onRemove={handleDeleteLabel}
              removeLoading={isPending}
              name={label?.labelName}
            />
          )}
        </div>
      }
    />
  );
};

export default Label;
